// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext} from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
import {Settings_context} from '../../settings_ctx';
import Icon_credit_card from '../../img/hola2023/icons/24/credit_card.svg';
import Icon_file_check from '../../img/hola2023/icons/24/file_check.svg';
import Icon_shield_check from '../../img/hola2023/icons/24/shield_check.svg';
import Icon_support from '../../img/hola2023/icons/24/support.svg';
import Icon_paper_plane from '../../img/hola2023/icons/24/paper_plane.svg';
import Icon_settings from '../../img/hola2023/icons/24/settings.svg';
import Icon_arrow from '../../img/hola2023/icons/24/arrow_up_right.svg';
import {t_use_cp} from './use_cp';
import styles from './cp_support.module.less';

const support_items = [
    {
        id: 'troubleshooting',
        title: 'Troubleshooting',
        icon: <Icon_settings/>,
        link: '/support/troubleshooting/',
    },
    {
        id: 'billing',
        title: 'Billing and payments',
        icon: <Icon_credit_card/>,
        link: '/support/billing',
    },
    {
        id: 'report',
        title: 'Report a problem',
        icon: <Icon_support/>,
        link: '/premium_support',
    },
    {
        id: 'contact',
        title: 'Contact us',
        icon: <Icon_paper_plane/>,
        link: '/contact',
    },
];

const legal_items = [
    {
        id: 'privacy',
        title: 'Privacy policy',
        icon: <Icon_shield_check/>,
        link: '/legal/privacy',
    },
    {
        id: 'eula',
        title: 'End user license',
        icon: <Icon_file_check/>,
        link: '/legal/sla',
    },
];

type t_cp_support_props = Partial<Pick<t_use_cp, 'back_btn' | 'is_mobile'>>;

export const CP_support = (props: t_cp_support_props)=>{
    const {back_btn, is_mobile} = props;
    const {theme} = useContext(Settings_context);
    return <div className={cn(styles.content, styles.support)}>
      <h1 className={styles.title}>{back_btn}Support</h1>
      <section className={styles.section}>
        <h2 className={styles.section_title}>Support topics</h2>
        <p className={theme.p3}>Here you can find the answers to our most
          common support issues</p>
        <div className={styles.support_items}>
          {support_items.map(({id, link, title, icon})=>{
              const cls = cn(styles.line, styles.item);
              return <Link key={id} to={link} className={cls}>
                <p className={styles.line_text}>{icon} {title}</p>
                <div className={styles.line_control}><Icon_arrow/></div>
              </Link>;
          })}
        </div>
        {!is_mobile && <p className={cn(theme.p3, styles.support_center)}>
          Didn't find what you were looking for? Visit
          our <Link to="/support" className={theme.link}>Support
          center</Link>
        </p>}
      </section>
      {!is_mobile && <h1 className={styles.title}>Legal</h1>}
      <section className={styles.section}>
        {is_mobile && <h2 className={cn(styles.section_title,
          styles.legal_title)}>Legal topics</h2>}
        <div className={styles.legal_items}>
          {legal_items.map(({id, link, title, icon})=>{
              const cls = cn(styles.line, styles.item);
              return <Link key={id} to={link} className={cls}>
                <p className={styles.line_text}>{icon} {title}</p>
                <div className={styles.line_control}><Icon_arrow/></div>
              </Link>;
          })}
        </div>
      </section>
    </div>;
};
